import axios from 'axios';
import { API_BASE_URL } from "../config/apiConfig";
const API_BASE =  API_BASE_URL;

const blogApi = {
  // Direct API search using axios
  searchBlogsWithAPI: async (keyword, authToken) => {
    if (!keyword || keyword.length < 2) return [];

    try {
      const encodedKeyword = encodeURIComponent(keyword.trim());
      
      // Direct axios call with full URL
      const response = await axios({
        method: 'GET',
        url: `${API_BASE}/blogs/search/${encodedKeyword}`,
        headers: {
          'Accept': 'application/json',
          'Authorization': authToken ? `Bearer ${authToken}` : '',
          'Content-Type': 'application/json',
        },
        timeout: 10000
      });
      
      // Handle different response structures
      let blogs = [];
      if (Array.isArray(response.data)) {
        blogs = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        blogs = response.data.data;
      } else if (response.data.blogs && Array.isArray(response.data.blogs)) {
        blogs = response.data.blogs;
      } else if (response.data.results && Array.isArray(response.data.results)) {
        blogs = response.data.results;
      }
      
      return blogs
        .filter(blog => blog.is_published !== false)
        .slice(0, 10)
        .map(blog => ({
          id: blog.id || blog._id,
          title: blog.title || 'Untitled',
          excerpt: blog.excerpt || blog.description || '',
          slug: blog.slug || `blog-${blog.id || blog._id}`,
          type: 'blog',
          category: blog.category,
          image: blog.featured_image || blog.image,
        }));
    } catch (error) {
      console.error('API search error:', error.message);
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
      }
      return [];
    }
  },

  // Client-side search as fallback using direct axios
  searchBlogs: async (query) => {
    if (!query || query.length < 3) return [];

    try {
      let allBlogs = [];
      
      // Try different endpoints with direct axios
      const endpoints = [
        `${API_BASE}/blogs`,
        `${API_BASE}/blogs`,
      ];
      
      for (const endpoint of endpoints) {
        try {
          const response = await axios({
            method: 'GET',
            url: endpoint,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            timeout: 5000
          });
          
          if (response.data) {
            allBlogs = Array.isArray(response.data) ? response.data : response.data.data || [];
            if (allBlogs.length > 0) break;
          }
        } catch (e) {
          console.warn(`Endpoint ${endpoint} failed:`, e.message);
          continue;
        }
      }
      
      if (allBlogs.length === 0) {
        console.warn('No blogs found from any endpoint');
        return [];
      }
      
      const lowerQuery = query.toLowerCase();
      
      return allBlogs
        .filter(blog => 
          blog.is_published !== false &&
          (blog.title?.toLowerCase().includes(lowerQuery) ||
           blog.excerpt?.toLowerCase().includes(lowerQuery) ||
           blog.category?.toLowerCase().includes(lowerQuery) ||
           blog.content?.toLowerCase().includes(lowerQuery))
        )
        .slice(0, 10)
        .map(blog => ({
          id: blog.id,
          title: blog.title,
          excerpt: blog.excerpt,
          slug: blog.slug || `post-${blog.id}`,
          type: 'blog',
          category: blog.category,
        }));
    } catch (error) {
      console.error('Client-side search error:', error);
      return [];
    }
  },

  // Main search function
  search: async (query, authToken = null) => {
    if (!query || query.length < 2) return [];
    
    const apiResults = await blogApi.searchBlogsWithAPI(query, authToken);
    
    if (apiResults.length > 0) {
      return apiResults;
    }
    
    return await blogApi.searchBlogs(query);
  }
};

export default blogApi;